module.exports = __webpack_public_path__ + "img/sec5_15.800c5493.jpg";